import React, { Suspense, useContext } from 'react';
import LoadingOverlay from 'atomic/loading-overlay';
import Spinner from 'atomic/spinner';
import { TeApiContext } from '@ecommerce/nest-ssr/common';
import Icon from 'atomic/icon';

import './modal.scss';

const ModalComponent: React.FC<any> = React.lazy(() => import('react-responsive-modal'));

const closeIcon = (
    <Icon name="x" color="dark" size={18} />
);

const Modal: React.FC<{
    showCloseIcon: boolean;
    center: boolean;
    isOpen: boolean;
    onClose: () => void;
    shouldCloseOnOverlayClick: boolean;
    modalClassName: string;
    overlayClassName?: string;
    children: React.ReactNode;
}> = props => {
    const api = useContext(TeApiContext);

    if (api === null) {
        throw new Error('Invalid API context');
    }

    const overlay = props.overlayClassName || null;
    const classNames = {
        modal: `${props.modalClassName} ${api.getDevice() === 'desktop' ? 'desktop' : 'mobile'}`,
        overlay
    };

    return (
        <Suspense fallback={<LoadingOverlay />}>
            <ModalComponent
                showCloseIcon={props.showCloseIcon}
                center={props.center}
                open={props.isOpen}
                onClose={props.onClose}
                closeIcon={closeIcon}
                classNames={classNames}
                blockScroll={false}
                closeOnOverlayClick={props.shouldCloseOnOverlayClick}
            >
                <Suspense fallback={<Spinner />}>
                    {props.children}
                </Suspense>
            </ModalComponent>
        </Suspense>
    );
};

export default Modal;
